import { action, computed, observable } from 'mobx';
import { FormMode } from './type';

export const TRANSFER_BROKER_MODE_KEY = '__TIGER_TRANSFER_BROKER_MODE_KEY__';

class TransferStore {
    /** 表单的操作模式 */
    @observable
    brokerMode: FormMode = 'create';

    /** 进度条是否可见 */
    @observable
    showProgressBar = true;

    /** 顶部进度条的当前值 */
    @observable
    step = 1;

    /** 顶部进度条的最大值 */
    @observable
    maxStep = 4;

    @computed
    get isEditMode() {
        return this.brokerMode === 'edit';
    }

    @action
    setBrokerMode(brokerMode: FormMode) {
        this.brokerMode = brokerMode;
        sessionStorage.setItem(TRANSFER_BROKER_MODE_KEY, brokerMode);
    }

    /**
     * 初始化 brokerMode 为 'create', 同时清除 sessionStorage 中的 brokerMode
     */
    @action
    clearBrokerMode() {
        this.brokerMode = 'create';
        sessionStorage.removeItem(TRANSFER_BROKER_MODE_KEY);
    }

    @action
    updateStep(step: number, maxStep?: number) {
        this.maxStep = maxStep || this.maxStep;
        this.step = Math.max(1, Math.min(step, this.maxStep));
    }

    @action
    setShowProgressBar(visible: boolean) {
        this.showProgressBar = visible;
    }
}

export default new TransferStore();
